<template>
	<div class="en_sear">
		<div class="se_pc" v-if="!isPhone">
			<div class="se_pc_box">
				<div class="pcse_wrap">
					<div class="pcse_box">
						<div class="pcse_put">
							<input type="text" v-model="newsKey" placeholder="please enter keywords">
							<button type="button" @click="searchBtn"></button>
						</div>
						<p class="pcse_num">{{totalNum}} search results</p>
					</div>
				</div>
				<div class="pro_list flex1">
					<div class="pro_item" v-for="(item,index) in proList" :key="index" data-aos="fade-up">
						<div class="ptm_img flex2">
							<img :src="staticImg+item.image">
						</div>
						<div class="ptm_info">
							<p class="ptm_name ellip">{{ item.name }}</p>
							<p class="ptm_desc ellip">{{ item.description }}</p>
							<div class="ptm_more" @click="toDetail(item)">
								<img src="@/images/productCenter/eng/more.png">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="se_ph" v-if="isPhone">
			<enHeader2 :searchShow="true" pageTitle="Jiannanchun"></enHeader2>
			<div class="network">
				<div class="nw_wrap">
					<div class="nw_search">
						<div class="am_list">
							<div class="am_input">
								<input type="text" v-model="newsKey" placeholder="please enter keywords">
							</div>
						</div>
						<div class="am_zoom">
							<img @click="searchBtn" src="@/images/zoom2.png">
						</div>
					</div>
				</div>
				<p class="totel_num">
					{{totalNum}} search results
				</p>
				<div class="pro_list">
					<div class="pro_item" v-for="(item,index) in proList" :key="index" data-aos="fade-up">
						<div class="ptm_img">
							<img :src="staticImg+item.image">
						</div>
						<div class="ptm_info">
							<p class="ptm_name">{{ item.name }}</p>
							<p class="ptm_desc">{{ item.description }}</p>
							<div class="ptm_more">
								<img @click="toDetail(item)" src="@/images/productCenter/eng/more.png">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			seshow: false,
			staticImg: this.$staticImg + '/',
			isPhone: this.$isMobile,
			newsKey: '',
			proList: [],
			totalNum: 0,
		}
	},
	created() {
		if (this.$route.query.newsKey) {
			this.newsKey = this.$route.query.newsKey;
		}
		this.enSearch();
	},
	methods: {
		handleSearch() {
			this.seshow = !this.seshow;
		},
		// 新闻列表
		async enSearch() {
			var data2 = {
				keyword: this.newsKey,
			};
			const res = await this.$api.enSearch(data2);
			if (res.code == 1) {
				if (res.data.length) {
					this.proList = res.data;
					this.totalNum = this.proList.length;
				}
			}
		},
		searchBtn() {
			this.proList = [];
			this.enSearch();
		},
		toDetail(item) {
			this.$router.push("/productDetail?gid=" + item.id);
		},
	}
}
</script>

<style lang="scss">
.en_sear {
    @font-face {
        font-family: 'SourceHanSerif';
        src: url('../../font/SourceHanSerifCN-Regular.otf');
    }
    font-family: 'SourceHanSerif';
	.se_pc {
		background-image: url("../../images/bgimg3.png");
		min-height: calc(100vh - 200px);
		padding-top: 120px;
		padding-bottom: 50px;
		min-width: 900px;
		.se_pc_box {
			box-sizing: border-box;
			max-width: 1296px;
			min-width: 900px;
			margin: 0 auto;
			padding: 80px 20px 90px;
			background-color: hsla(0, 0%, 100%, 0.6);
			min-height: 680px;
			.pcse_wrap {
				max-width: 900px;
				margin: 0 auto;
				.pcse_box {
					.pcse_put {
						display: flex;
						align-items: center;
						background-color: #fff;
						box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
						height: 69px;
						input {
							flex: 1;
							color: #262626;
							font-size: 36px;
							height: 69px;
							padding: 0 42px;
							border: none;
							outline: none;
							margin-right: 2px;
						}
						button {
							width: 88px;
							flex-shrink: 0;
							height: 69px;
							background-image: url("../../images/news/zoom1.png");
							background-repeat: no-repeat;
							background-position: 50%;
							border: none;
							outline: none;
							background-color: #fff;
							cursor: pointer;
						}
					}
					.pcse_num {
						color: #666;
						font-size: 22px;
						margin: 20px 0;
						text-align: left;
					}
				}
			}
			.pro_list {
				max-width: 900px;
				margin: 0 auto;
				flex-wrap: wrap;
				.pro_item {
					margin-bottom: 60px;
					&:nth-child(2n) {
						margin-right: 0;
					}
					.ptm_img {
						width: 420px;
						height: 420px;
						overflow: hidden;
						background-color: #ece5de;
						img {
							width: 300px;
							height: 300px;
						}
					}
					.ptm_info {
						width: 420px;
						background-color: #fff;
						padding: 20px 10px;
						box-sizing: border-box;
						.ptm_name {
							font-size: 18px;
							font-weight: bold;
						}
						.ptm_desc {
							font-size: 12px;
							margin-top: 15px;
						}
						.ptm_more {
							margin-top: 28px;
							img {
								width: 90px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.se_pc {
			.se_pc_box {
				width: 1000px;
				padding: 50px 20px 90px;
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.se_pc {
			background-image: url("../../images/bgimg3.png");
			min-height: calc(100vh - 200px);
			padding-top: 120px;
			padding-bottom: 50px;
			.se_pc_box {
				max-width: 800px;
				min-width: 800px;
				padding: 60px 20px 60px;
				.pcse_wrap {
					max-width: 600px;
					.pcse_box {
						.pcse_put {
							height: 60px;
							input {
								height: 60px;
								padding: 0 20px;
							}
							button {
								width: 60px;
								height: 60px;
								background-size: 40%;
							}
						}
						.pcse_num {
							font-size: 22px;
						}
					}
				}
				.pro_list {
					max-width: 600px;
					margin: 0 auto;
					flex-wrap: wrap;
					.pro_item {
						margin-bottom: 30px;
						&:nth-child(2n) {
							margin-right: 0;
						}
						.ptm_img {
							width: 280px;
							height: 280px;
							overflow: hidden;
							background-color: #ece5de;
							img {
								width: 240px;
                                height: auto;
							}
						}
						.ptm_info {
							width: 280px;
							padding: 20px 10px;
							.ptm_name {
								font-size: 18px;
							}
							.ptm_more {
								margin-top: 20px;
								img {
									width: 80px;
								}
							}
						}
					}
				}
			}
		}
	}
	.se_ph {
		background-image: url("../../images/bgimg3.png");
		padding-top: 1.23rem;
		min-height: 90vh;
		.network {
			.nw_wrap {
				padding: 0.4rem 0.53rem 0.47rem;
				box-sizing: border-box;
				.nw_search {
					background-color: #fff;
					height: 1.17rem;
					padding: 0 0.33rem;
					border-radius: 1.17rem;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.am_list {
						box-sizing: border-box;
						flex: 1;
						.am_input {
							input {
								color: #666;
								font-size: 17px;
								width: 100%;
								height: 1.17rem;
								border-radius: 1.17rem;
								background-color: #fff;
								border: none;
								outline: none;
								padding: 0 5px;
							}
						}
					}
					.am_zoom {
						width: 1rem;
						text-align: center;
						img {
							width: 0.45rem;
						}
					}
				}
			}
			.totel_num {
				padding: 0 0.53rem;
				color: #666;
				text-align: left;
			}
			.pro_list {
				padding: 0.68rem 0.56rem;
				.pro_item {
					margin-bottom: 0.5rem;
					.ptm_img {
						width: 100%;
						height: 7.97rem;
						overflow: hidden;
						background-color: #ece5de;
						img {
							width: 100%;
						}
					}
					.ptm_info {
						background-color: #fff;
						padding: 0.58rem 1.16rem;
						.ptm_name {
							font-size: 0.5rem;
							font-weight: bold;
						}
						.ptm_desc {
							font-size: 12px;
							margin-top: 0.35rem;
						}
						.ptm_more {
							margin-top: 0.5rem;
							img {
								width: 2.17rem;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
}
</style>